import { render, staticRenderFns } from "./Decoration11.vue?vue&type=template&id=55b6cb5f&scoped=true"
import script from "./Decoration11.vue?vue&type=script&lang=js"
export * from "./Decoration11.vue?vue&type=script&lang=js"
import style0 from "./Decoration11.vue?vue&type=style&index=0&id=55b6cb5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6cb5f",
  null
  
)

export default component.exports